import { LifebuoyIcon } from "@phosphor-icons/react/dist/csr/Lifebuoy";
import {
  useSidebar,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@volca/ui/components/ui/sidebar";
import { openSupportChat, useHasPylonAccess } from "@/core/pylon";
import { usePylonChatAnchor } from "@/core/pylon/use-pylon-chat-anchor";

export const SidebarNavSupport = () => {
  const hasAccess = useHasPylonAccess();
  const { state, isMobile, setOpenMobile } = useSidebar();
  const ref = usePylonChatAnchor(hasAccess, "right", state === "collapsed");
  if (!hasAccess) return null;

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        ref={ref}
        tooltip="Contact support"
        onClick={() => {
          if (isMobile) setOpenMobile(false);
          openSupportChat();
        }}
      >
        <LifebuoyIcon />
        <span>Contact support</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
